import { GridColumn as Column } from '@progress/kendo-react-grid';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PrimaryButton,
  TertiaryButton
} from 'src/components/shared/Button/Button';
import { DateCell } from 'src/components/shared/DataGrid/DateCell';
import { EditableGrid } from 'src/components/shared/DataGrid/EditableGrid/EditableGrid';
import { ModalFooter } from 'src/components/shared/Modal/Modal';
import { GradeCorrectionDto } from 'src/store/grades/grade';

type Props = {
  corrections: GradeCorrectionDto[];
  onCorrectionsChanged: (corrections: GradeCorrectionDto[]) => void;
  onCancel: () => void;
  onSubmit: () => void;
};

export const CorrectionForm: React.FC<Props> = props => {
  const { corrections, onCorrectionsChanged, onSubmit, onCancel } = props;
  const { t } = useTranslation();

  return (
    <Fragment>
      <EditableGrid
        items={corrections}
        onItemsChange={items => {
          onCorrectionsChanged(items);
        }}
      >
        <Column
          field="parameter.name"
          title={t('parameter.singular')}
          width="220px"
        />
        <Column
          field="instrument.name"
          title={t('instrument.singular')}
          width="220px"
        />
        <Column
          field="correctionPart"
          title={t('grade.correctionPart')}
          editor="numeric"
        />
        <Column field="user.initials" title={t('user.initials')} />
        <Column
          field="correctionDate"
          title={t('grade.correctionDate')}
          cell={props => <DateCell {...props} />}
        />
      </EditableGrid>

      <ModalFooter>
        <TertiaryButton
          onClick={onCancel}
          label={t('cancel')}
          className="mr-32"
        />
        <PrimaryButton onClick={onSubmit} label={t('save.verb')} />
      </ModalFooter>
    </Fragment>
  );
};
